import React from 'react';
import './Add_step_4.css';
import { Link } from 'react-router-dom';

import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import gg_plus_logo from '../../../../images/logos/gg_plus/gg_plus_103.png';

import config from '../../../../utils/config';
import amplitude from 'amplitude-js';

import {
    logGgPlusFeatureGateViewed,
    logGgPlusUpgradeClicked,
} from '../../../../utils/ggPlusAnalytics.js';

amplitude.getInstance().init(config.amp_key);

class Add_step_4 extends React.Component {
    constructor(props) {
        super(props);
        this.gateLogged = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentStep === 4 && prevProps.currentStep !== 4) {
            this.maybeLogPostRecipientGate();
        }
    }

    componentDidMount() {
        this.maybeLogPostRecipientGate();
    }

    maybeLogPostRecipientGate() {
        if (this.gateLogged || this.props.currentStep !== 4 || !this.shouldShowGgPlusUpsell()) {
            return;
        }
        this.gateLogged = true;
        logGgPlusFeatureGateViewed({ source: 'post_recipient_creation' });
    }
    // Build link-destination URL, preserving receive source and plan return path.
    buildLinkDestinationPath() {
        const params = new URLSearchParams();
        if (this.props.source) params.set('source', this.props.source);
        if (this.props.new_account_id) params.set('plan', String(this.props.new_account_id));
        const qs = params.toString();
        return qs ? `/link_destination?${qs}` : '/link_destination';
    }

    // Membership page with analytics source + return to this recipient's plan page.
    buildMembershipPath() {
        const returnTo = encodeURIComponent(`/plan/${this.props.new_account_id}`);
        return `/settings/account/membership?source=post_recipient_creation&return_to=${returnTo}`;
    }

    // Step 4 upsell: free users only (all recipients, including receive/redemption path).
    shouldShowGgPlusUpsell() {
        try {
            const ent = JSON.parse(localStorage.getItem('entitlements'));
            return !(ent && ent.isPremium);
        } catch (e) {
            return true;
        }
    }

    handleGgPlusUpsellClick() {
        logGgPlusUpgradeClicked({ source: 'post_recipient_creation' });
    }

    renderGgPlusUpsellCard() {
        if (!this.shouldShowGgPlusUpsell()) return null;

        const childName = (this.props.account_name || '').trim() || 'your child';

        return (
            <div className="add_step_4_gg_plus_card">
                <img src={gg_plus_logo} alt="GG+" className="add_step_4_gg_plus_logo" />
                <p className="add_step_4_gg_plus_headline">
                    Grow more support for {childName}
                </p>
                <p className="add_step_4_gg_plus_body">
                    Unlock monthly gifting, gift matching, and new tools that allow family and friends to give more consistently over time.
                </p>
                <Link
                    to={this.buildMembershipPath()}
                    className="bold green_text add_step_4_gg_plus_cta"
                    onClick={this.handleGgPlusUpsellClick}
                >
                    Try GG+ free
                </Link>
            </div>
        );
    }

    render () {
        if (this.props.currentStep !== 4) {
            return null;
        }
        
        
        return (
           <div>
                <h2 className='center'>You're all set!</h2>    
                
                <p>1. {this.props.account_name}'s gifting page is now live! Share it with friends and family so they can start sending you great gifts!</p>
                <MasterButton
                    buttonText={`See ${this.props.account_name}'s Gifting Page`}
                    
                    //// need to get the url for the gifting page! pull it from the props when submitting api in previous page
                    handleButtonClick={() => {amplitude.getInstance().logEvent('new recipient: go to gifting page'); window.open(this.props.gifting_page_url, '_blank').focus()}}
                    links={false}
                    linkTo={this.props.gifting_page_url}

                    notSticky={true}
                    icon={'launch'}
                    />

                <div className="margin_bottom_40"></div>

                <p>2. Start saving for {this.props.account_name} by linking a financial account and redeeming gifts to that account</p>
                <MasterButton
                    buttonText='Link a financial account'
                    handleButtonClick={() => {this.props.updateActiveRecipient(this.props.account_name); amplitude.getInstance().logEvent('new recipient: go to add fund'); }}
                    links={true}
                    linkTo={this.buildLinkDestinationPath()}
                    notSticky={true}
                    />

                {this.renderGgPlusUpsellCard()}
                
                <div className="margin_bottom_40"></div>

           </div>
        );
    }
}

export default Add_step_4;
